import { Tooltip, DEPRECATED_TOOLTIP_TEXT } from '@components/tooltip';
import { Box, Typography } from '@mui/material';
import { useStore } from '@store/GlobalStore';
import { GridColumn } from '@store/types/UserStoreSlice.type';
import { adjustLineHeight } from '@theme/styleOverrides/typography';
import { shallow } from 'zustand/shallow';

export function CollapsedField({
  label,
  value,
  deprecated,
  preserveLineBreaks,
}: {
  label: string | null;
  value?: string;
  deprecated?: boolean | null;
  /** Show the value's line breaks and blank lines (multi-line text areas). */
  preserveLineBreaks?: boolean;
}) {
  const layoutPreferences = useStore((state) => state.layoutPreferences, shallow);
  const leftAlign = layoutPreferences.offeringGridColumns === GridColumn.SINGLE_COLUMN;

  return (
    <Box
      data-testid='qfc-collapsed-field'
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: leftAlign ? 'flex-start' : 'space-between',
      }}
    >
      <Tooltip title={deprecated ? DEPRECATED_TOOLTIP_TEXT : ''}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
            alignItems: 'center',
            gap: 1,
            lineHeight: `${adjustLineHeight(14, layoutPreferences.fontSize)}px`,
          }}
        >
          <Typography
            variant='bodySmall'
            sx={{
              color: deprecated ? 'text.subdued' : 'text.caption',
              textDecoration: deprecated ? 'line-through' : 'none',
              paddingLeft: 1,
              lineHeight: `${adjustLineHeight(14, layoutPreferences.fontSize)}px`,
            }}
          >
            {label ?? 'Missing Label'}
          </Typography>
        </Box>
      </Tooltip>
      <Typography
        variant='button'
        sx={{
          color: 'secondary.main',
          cursor: 'auto',
          paddingLeft: 1,
          paddingRight: 2,
          textAlign: preserveLineBreaks ? 'left' : 'right',
          whiteSpace: preserveLineBreaks ? 'pre-wrap' : undefined,
          lineHeight: `${adjustLineHeight(14, layoutPreferences.fontSize)}px`,
        }}
      >
        {value ?? '-'}
      </Typography>
    </Box>
  );
}
